import { type FC } from 'react';

import classNames from 'classnames';

import { type BaseIconOuterProps } from '@/components/common/icons/BaseIcon';
import { ChevronDownIcon } from '@/components/common/icons/ChevronDownIcon';

import styles from './ToggleArrow.module.scss';

type ToggleArrowProps = BaseIconOuterProps & {
  isOpen?: boolean;
};

export const ToggleArrow: FC<ToggleArrowProps> = (props) => {
  const { className, isOpen, ...iconProps } = props;

  return <ChevronDownIcon className={classNames(styles.root, { [styles.open]: isOpen }, className)} {...iconProps} />;
};
